import { makeAutoObservable } from 'mobx';
import apiService from 'Service'

function normalizeDashboardPayload(raw) {
    if (!raw || typeof raw !== 'object') return undefined
    if (raw.TotalsCounter) return raw
    if ('Providers' in raw || 'Invoices' in raw || 'Withholdings' in raw) {
        return {
            ...raw,
            TotalsCounter: {
                ProvidersCount: raw.Providers ?? 0,
                InvoiceCountTotal: raw.Invoices ?? 0,
                InvoiceCountMonth: raw.InvoiceCountMonth ?? 0,
                WithholdingsCountTotal: raw.Withholdings ?? 0,
                WithholdingsCountMonth: raw.WithholdingsCountMonth ?? 0,
            },
        }
    }
    return undefined
}

class dashboardStore {
    isLoading = true
    data = undefined
    error = false
    lastUpdatedAt = undefined

    constructor() {
        makeAutoObservable(this)
    }

    reset(){
        this.setIsLoading(true)
        this.setData(undefined)
        this.error = false
        this.lastUpdatedAt = undefined
    }

    setData(newData){
        this.data = newData
    }
    setIsLoading(value){
        this.isLoading = value
    }

    fetchData(){
        this.setIsLoading(true)
        this.error = false
        return apiService.Dashboards.get()
            .then(data => {
                this.setData(normalizeDashboardPayload(data))
                this.lastUpdatedAt = new Date()
            })
            .catch(() => {
                this.setData(undefined)
                this.error = true
            })
            .finally(() => { this.setIsLoading(false) })
    }
}

export default new dashboardStore();
